export * from './shorten.service';
import { ShortenApiService } from './shorten.service';
export const APIS = [ShortenApiService];
